import { Component, OnInit } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { AuthService } from "app/auth/auth.service";
import { NavParams, ViewController } from "ionic-angular";
import { PatientAllergiesService } from "providers/patient-charts/patient-allergies-service";
import { ReferralsServiceProvider } from "providers/patient-charts/referrals-service";
import { ReportExecutionService } from "providers/report-execution-service/report-execution.service";

const DECLINED_DASHBOARD_NAME = "patient_decline";

@Component({
  selector: "decline-dashboard-popover",
  templateUrl: "decline-dashboard-popover.html",
})
export class DeclineDashboardPopover implements OnInit {
  patientChartId: number;
  tenantId: number;

  qsDashboardUrl: SafeResourceUrl;
  loadingQsUrl: boolean = true;
  dashboardUrl: string;
  constructor(
    public allergySvc: PatientAllergiesService,
    public referralsService: ReferralsServiceProvider,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public reportService: ReportExecutionService,
    private sanitizer: DomSanitizer,
    private authService: AuthService,
    private authSvc: AuthService
  ) {
    this.patientChartId = this.navParams.get("patientChartId");
    // this.tenantId = this.authSvc.getUserOrganization();
    this.tenantId = this.authSvc.getUser().tenantId;
  }

  closeModal() {
    this.viewCtrl.dismiss();
  }

  ngOnInit(): void {
    this.getQuicksightDashboard();
  }

  async getQuicksightDashboard(): Promise<void> {
    let payload = {
      username: this.authSvc.getUser().tenantId.toString(),
      id_token: await this.authSvc.getValidIdToken(),
      email: this.authSvc.getUser().email,
      dashboard_name: DECLINED_DASHBOARD_NAME,
      parameters: {
        tenant_id: this.authSvc.getUser().tenantId.toString(),
        patient_chart_id: this.patientChartId.toString(),
      },
    };
    this.getQuicksightDashboardForRegisteredUser(payload);
  }

  getQuicksightDashboardForRegisteredUser(payload: any): void {
    this.reportService.increaseSpinnerCount();
    this.reportService
      .getQuicksightDashboardAPIForRegisteredUser(payload)
      .subscribe(
        (response) => {
          if (response) {
            this.qsDashboardUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
              response.toString()
            );
            this.loadingQsUrl = false;
          }
          this.reportService.decreaseSpinnerCount();
        },
        (err) => {
          console.error("Failed to retrieve QuickSight Dashboard.", err);
          this.reportService.presentErrorToast(
            err,
            "Failed to retrieve QuickSight Dashboard."
          );
          this.reportService.decreaseSpinnerCount();
          this.closeModal();
          this.loadingQsUrl = false;
        },
        () => {}
      );
  }
}



// WEBPACK FOOTER //
// ./src/navigation/components/decline-dashboard-popover/decline-dashboard-popover.ts